
const extractTemplateFromBlock = (props) => {
  let object = { ...props }
  const blocksTemplates = {
    blockDefault: {
      slotLeftTeaserValue: 'LayoutFeatured',
      slotCenterTeaserValue: 'LayoutDefault',
      slotRightTeaserValue: 'LayoutGrid3',
      slotTemplate: 'Template5050100'
    },
    blockDefaultNoGrid: {
      slotLeftTeaserValue: 'LayoutFeatured',
      slotCenterTeaserValue: 'LayoutDefault',
      slotRightTeaserValue: 'LayoutDefault',
      slotTemplate: 'Template5050'
    },
    blockDefaultFive: {
      slotLeftTeaserValue: 'LayoutDefault',
      slotCenterTeaserValue: 'LayoutDefault',
      slotRightTeaserValue: 'LayoutGrid3',
      slotTemplate: 'Template5050100'
    },
    blockDefaultGrid: {
      slotLeftTeaserValue: 'LayoutGrid3',
      slotCenterTeaserValue: '',
      slotRightTeaserValue: '',
      slotTemplate: 'Template100'
    },
    blockInfomercial: {
      slotLeftTeaserValue: 'LayoutGridInfocom',
      slotCenterTeaserValue: '',
      slotRightTeaserValue: '',
      slotTemplate: 'Template100'
    },
    blockDefaultSide: {
      slotLeftTeaserValue: 'LayoutGrid4',
      slotCenterTeaserValue: '',
      slotRightTeaserValue: '',
      slotTemplate: 'TemplateSideBox'
    },
    blockFeaturedNoImage: {
      slotLeftTeaserValue: 'LayoutFeaturedNoImage',
      slotCenterTeaserValue: '',
      slotRightTeaserValue: '',
      slotTemplate: 'Template100'
    },
    blockFeatureImage: {
      slotLeftTeaserValue: 'LayoutFeatured',
      slotCenterTeaserValue: '',
      slotRightTeaserValue: '',
      slotTemplate: 'Template100'
    },
    blockSuperFeatureImage: {
      slotLeftTeaserValue: 'LayoutFeatured',
      slotCenterTeaserValue: '',
      slotRightTeaserValue: '',
      slotTemplate: 'TemplateSuperManchete'
    },
    blockSuperFeatureRelated: {
      slotLeftTeaserValue: 'LayoutFeaturedImage',
      slotCenterTeaserValue: '',
      slotRightTeaserValue: '',
      slotTemplate: 'TemplateSuperManchete'
    },
    blockVideoFeatured: {
      slotLeftTeaserValue: 'LayoutVideoFeatured',
      slotCenterTeaserValue: '',
      slotRightTeaserValue: '',
      slotTemplate: 'Template100'
    },
    blockVideoHome: {
      slotLeftTeaserValue: 'LayoutVideoHome',
      slotCenterTeaserValue: 'LayoutVideoHome',
      slotRightTeaserValue: 'LayoutVideoHome',
      slotTemplate: 'TemplateVideos'
    },
    blockVideoLive: {
      slotLeftTeaserValue: 'LayoutVideoLive',
      slotCenterTeaserValue: '',
      slotRightTeaserValue: '',
      slotTemplate: 'TemplateVideoLive'
    },
    blockNone: {}
  }
  const selectedTemplate = blocksTemplates[props?.slotBlockTemplate]
  if (selectedTemplate) {
    object = { ...props, ...selectedTemplate }
  }
  return object
}


export { extractTemplateFromBlock }
